import { useEffect, useState } from "react";
import api from "../../lib/api";
import { fmtDate } from "../../lib/status";
import { toast } from "sonner";

export default function AdminTickets() {
    const [tickets, setTickets] = useState([]);
    const [open, setOpen] = useState(null);
    const [msg, setMsg] = useState("");

    const load = () => api.get("/tickets").then(({ data }) => setTickets(data));
    useEffect(() => {
        load();
    }, []);

    const reply = async () => {
        if (!msg.trim() || !open) return;
        try {
            await api.post(`/tickets/${open.id}/messages`, { message: msg });
            toast.success("Reply sent");
            setMsg("");
            load();
            const { data } = await api.get("/tickets");
            const updated = data.find((t) => t.id === open.id);
            if (updated) setOpen(updated);
        } catch (e) {
            toast.error("Failed");
        }
    };

    const setStatus = async (status) => {
        if (!open) return;
        try {
            await api.post(`/tickets/${open.id}/status`, { status });
            toast.success(`Status: ${status}`);
            load();
            setOpen({ ...open, status });
        } catch (e) {
            toast.error("Failed");
        }
    };

    return (
        <div className="space-y-6">
            <div>
                <div className="lx-label text-[#D4AF37] mb-2">Support</div>
                <h1 className="font-serif text-4xl text-white">Tickets</h1>
            </div>
            <div className="grid lg:grid-cols-12 gap-4">
                <div className="lg:col-span-5 space-y-2">
                    {tickets.length === 0 && (
                        <div className="lx-card-dark p-10 text-center text-white/60">
                            No tickets.
                        </div>
                    )}
                    {tickets.map((t) => (
                        <button
                            key={t.id}
                            onClick={() => setOpen(t)}
                            data-testid={`adm-ticket-${t.ticket_number}`}
                            className={`block w-full text-left p-5 lx-card-dark transition ${
                                open?.id === t.id ? "border-[#D4AF37]" : ""
                            }`}
                        >
                            <div className="flex items-center gap-3 mb-1 flex-wrap">
                                <span className="lx-label text-[#D4AF37]">{t.ticket_number}</span>
                                <span className="text-[10px] uppercase tracking-wider text-white/60">
                                    {t.status}
                                </span>
                            </div>
                            <div className="font-serif text-lg text-white">{t.subject}</div>
                            <div className="text-xs text-white/60 mt-1">
                                {t.priority} · {fmtDate(t.created_at)}
                            </div>
                        </button>
                    ))}
                </div>
                {open && (
                    <div className="lg:col-span-7 lx-card-dark p-6">
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <div className="lx-label text-[#D4AF37]">{open.ticket_number}</div>
                                <div className="font-serif text-2xl text-white">
                                    {open.subject}
                                </div>
                            </div>
                            <select
                                value={open.status}
                                onChange={(e) => setStatus(e.target.value)}
                                data-testid="adm-ticket-status-select"
                                className="bg-[#180A21] border border-[#2B1438] text-white px-3 py-1 text-sm"
                            >
                                {["open", "in_progress", "resolved", "closed", "reopened"].map(
                                    (s) => (
                                        <option key={s}>{s}</option>
                                    ),
                                )}
                            </select>
                        </div>
                        <div className="text-sm text-white/80 bg-[#180A21] p-4 mb-4">
                            {open.description}
                        </div>
                        <div className="space-y-3 mb-4 max-h-80 overflow-y-auto">
                            {(open.messages || []).map((m) => (
                                <div
                                    key={m.id}
                                    className={`p-3 ${m.by_role === "customer" ? "bg-[#180A21]" : "bg-[#D4AF37]/10 border border-[#D4AF37]/20"}`}
                                >
                                    <div className="lx-label text-[#D4AF37] mb-1">{m.by_role}</div>
                                    <div className="text-sm text-white">{m.message}</div>
                                </div>
                            ))}
                        </div>
                        <div className="flex gap-2">
                            <input
                                value={msg}
                                onChange={(e) => setMsg(e.target.value)}
                                placeholder="Reply…"
                                data-testid="adm-ticket-reply-input"
                                className="flex-1 bg-[#180A21] border border-[#2B1438] text-white px-3 py-2"
                            />
                            <button
                                onClick={reply}
                                data-testid="adm-ticket-reply-send"
                                className="lx-btn-gold px-4"
                            >
                                Send
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
